<template>
  <div class="container-withdraw-account" :class="[packageName]">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.WithdrawalAccount.k038') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>

      <!-- 提现名 -->
      <div class="select">
        <span>{{ $t('lang.WithdrawalAccount.k026') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>

      <div class="select">
        <span>{{ $t('lang.WithdrawalAccount.k028') }}</span>
        <input style="color: #333" type="text" :placeholder="$t('lang.WithdrawalAccount.k002')" v-model.trim="accountName" />
      </div>
      <p class="paypal-tips">{{ $t('lang.WithdrawalAccount.k001') }}</p>

      <div class="select">
        <span>{{ $t('lang.BaseCommon.k103') }}</span>
        <div class="select-account">
          <input type="text" :placeholder="$t('lang.WithdrawalAccount.k031')" v-model="accountId" />
        </div>
      </div>

      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ 'save-btn-act': this.saveFlag() }" @click="handleSave">
        {{ cfgId ? $t('lang.BaseCommon.k008') : $t('lang.WithdrawalAccount.k036') }}
      </div>
    </div>

    <!-- 弹窗 -->
    <van-dialog v-model="showDialog" close-on-click-overlay="true" :showConfirmButton="false">
      <div class="pix-dialog">
        <div class="title">{{ $t('lang.WithdrawalAccount.k035') }}</div>
        <div class="tip">{{ $t('lang.WithdrawalAccount.k034') }}</div>
        <div class="account">123.456.789-00</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiEditWithdrawAccount } from '@/api/imee.js'

import _debounce from 'lodash/debounce'
import baseMixin from '../base.mixin.js'

export default {
  mixins: [baseMixin],
  data() {
    return {}
  },
  methods: {
    // 保存
    handleSave: _debounce(
      function () {
        // 去掉空格
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '')

        // 判断emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          this.$client.showToast(this.$t('lang.WithdrawalAccount.k027'))
          return
        }

        // 验证邮箱格式
        if (this.withdrawalMethod === 'Paypal') {
          const mailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          if (!mailReg.test(this.accountId)) {
            this.accountId = ''
            this.$client.showToast(this.$t('lang.WithdrawalAccount.k030'))
            return
          }
        }

        const data = {
          accountId: this.accountId,
          accountName: this.accountName,
        }

        // edit
        if (this.cfgId) {
          apiEditWithdrawAccount(data, this.cfgId).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
        // add
        else {
          data.withdrawalMethod = this.withdrawalMethod
          apiBindWithdrawAccount(data).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
      },
      3000,
      {
        leading: true,
        trailing: false,
      }
    ),
    // 保存校验
    saveFlag() {
      if (this.accountId && this.accountName) {
        return true
      }

      return false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../base.scss';
</style>
